import React from 'react'

function Education() {
  return (
    <div className='experience' id='education'><hr /><h1>Education</h1>
        <div>
            <h1 className='post'>BITS PILANI</h1>
            <h2>Bachelor's Degree</h2>
            <h4 className='description'>DESIGN & COMPUTING</h4>
        </div>
        <div>
            <h1 className='post'>M.B.B.L INTER COLLEGE</h1>
            <h2>Senior School Certificate Examination</h2>
            <h4 className='description'>PCM</h4>
        </div>
        <div>
            <h1 className='post'>RESONANCE INTERNATIONAL SCHOOL</h1>
            <h2>Secondary School Examination</h2>
            <h4 className='description'>CGPA:7.8</h4>
        </div>
    </div>
  )
}

export default Education